import type { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { ArrowRightIcon } from '@/common/assets';

export default function ArrowButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { className, ...rest } = props;

  return (
    <button
      className={twMerge('p-2 bg-pmw-arrow-button rounded-sm cursor-pointer', className)}
      {...rest}
    >
      <ArrowRightIcon className="text-brand110" />
    </button>
  );
}
